export const apiOriginUrl: string = 'https://api.amitel.azureo.eu';
export const ceriServerUrl: string = 'https://api.amitel.eu:2323/api_amitel/';

export const environment = {
  production: false,
  sendTo: 'geoffrey.limmacher@pendoralab.com',
  local: '/assets/data',
  origin: `${apiOriginUrl}`,
  apiV1: '/api/v1/',
  service: {
    core: '/bff/service-core'
  },
  ceriServerUrl,
  auth0: {
    domain: 'https://amitel-stage.eu.auth0.com',
    clientId: 'XDoj7NGW5jMQHtX9fsYV84kpe4WMM0mL',
    audience: 'https://api.amitel.azureo.eu'
  },
};
